"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleInfoItemsCreatorLabels = void 0;
require("../types");
const getScheduleInfoItemsCreatorLabels = (rowFirstTitle, rowFirstLabelSingular, rowFirstLabelPlural, rowSecondTitle, rowSecondLabelSingular, rowSecondLabelPlural, rowThirdTitle, rowThirdLabelSingular, rowThirdLabelPlural) => {
    const labels = {
        rowFirst: {
            title: rowFirstTitle,
            wordForm: {
                singular: rowFirstLabelSingular,
                plural: rowFirstLabelPlural,
            },
        },
        rowSecond: rowSecondTitle && rowSecondLabelSingular && rowSecondLabelPlural
            ? {
                title: rowSecondTitle,
                wordForm: {
                    singular: rowSecondLabelSingular,
                    plural: rowSecondLabelPlural,
                },
            }
            : undefined,
        rowThird: rowThirdTitle && rowThirdLabelSingular && rowThirdLabelPlural
            ? {
                title: rowThirdTitle,
                wordForm: {
                    singular: rowThirdLabelSingular,
                    plural: rowThirdLabelPlural,
                },
            }
            : undefined,
    };
    return labels;
};
exports.getScheduleInfoItemsCreatorLabels = getScheduleInfoItemsCreatorLabels;
//# sourceMappingURL=getScheduleInfoItemsCreatorLabels.js.map